const ICONIFY_BASE = process.env.NODE_ENV === 'development'
  ? '/iconify-api'
  : 'https://api.iconify.design';
const CACHE_TTL = 24 * 60 * 60 * 1000;

// Static fallback — always available, no network needed
const STATIC_COLLECTIONS = [
  // Popular
  { id: 'ph', name: 'Phosphor', count: 9072, iconifyCategory: 'General' },
  { id: 'tabler', name: 'Tabler Icons', count: 6092, iconifyCategory: 'General' },
  { id: 'mdi', name: 'Material Design Icons', count: 7447, iconifyCategory: 'General' },
  { id: 'fluent', name: 'Fluent UI System Icons', count: 19207, iconifyCategory: 'General' },
  { id: 'ri', name: 'Remix Icon', count: 3188, iconifyCategory: 'General' },
  { id: 'bi', name: 'Bootstrap Icons', count: 2078, iconifyCategory: 'General' },
  { id: 'heroicons', name: 'Heroicons', count: 1288, iconifyCategory: 'General' },
  { id: 'lucide', name: 'Lucide', count: 1694, iconifyCategory: 'General' },
  { id: 'carbon', name: 'Carbon', count: 2491, iconifyCategory: 'General' },
  { id: 'octicon', name: 'Octicons', count: 726, iconifyCategory: 'General' },
  // General
  { id: 'ant-design', name: 'Ant Design Icons', count: 831, iconifyCategory: 'General' },
  { id: 'clarity', name: 'Clarity', count: 1053, iconifyCategory: 'General' },
  { id: 'codicon', name: 'VS Code Icons', count: 463, iconifyCategory: 'General' },
  { id: 'eos-icons', name: 'EOS Icons', count: 1000, iconifyCategory: 'General' },
  { id: 'eva-icons', name: 'Eva Icons', count: 490, iconifyCategory: 'General' },
  { id: 'feather', name: 'Feather Icons', count: 287, iconifyCategory: 'General' },
  { id: 'gridicons', name: 'Gridicons', count: 201, iconifyCategory: 'General' },
  { id: 'iconamoon', name: 'IconaMoon', count: 1100, iconifyCategory: 'General' },
  { id: 'iconoir', name: 'Iconoir', count: 1609, iconifyCategory: 'General' },
  { id: 'ion', name: 'IonIcons', count: 1356, iconifyCategory: 'General' },
  { id: 'jam', name: 'Jam Icons', count: 940, iconifyCategory: 'General' },
  { id: 'la', name: 'Line Awesome', count: 1544, iconifyCategory: 'General' },
  { id: 'lets-icons', name: "Let's Icons", count: 2400, iconifyCategory: 'General' },
  { id: 'line-md', name: 'Material Line Icons', count: 400, iconifyCategory: 'General' },
  { id: 'majesticons', name: 'Majesticons', count: 760, iconifyCategory: 'General' },
  { id: 'material-symbols', name: 'Material Symbols', count: 11000, iconifyCategory: 'General' },
  { id: 'mdi-light', name: 'Material Design Light', count: 267, iconifyCategory: 'General' },
  { id: 'mingcute', name: 'MingCute Icon', count: 3200, iconifyCategory: 'General' },
  { id: 'mono-icons', name: 'Mono Icons', count: 193, iconifyCategory: 'General' },
  { id: 'mynaui', name: 'Myna UI Icons', count: 900, iconifyCategory: 'General' },
  { id: 'nimbus', name: 'Nimbus', count: 192, iconifyCategory: 'General' },
  { id: 'oi', name: 'Open Iconic', count: 223, iconifyCategory: 'General' },
  { id: 'oui', name: 'OpenSearch UI', count: 360, iconifyCategory: 'General' },
  { id: 'pajamas', name: 'GitLab SVGs', count: 498, iconifyCategory: 'General' },
  { id: 'pepicons-pencil', name: 'Pepicons Pencil', count: 540, iconifyCategory: 'General' },
  { id: 'pepicons-pop', name: 'Pepicons Pop', count: 540, iconifyCategory: 'General' },
  { id: 'pixelarticons', name: 'Pixelart Icons', count: 480, iconifyCategory: 'General' },
  { id: 'prime', name: 'Prime Icons', count: 464, iconifyCategory: 'General' },
  { id: 'quill', name: 'Quill Icons', count: 700, iconifyCategory: 'General' },
  { id: 'radix-icons', name: 'Radix Icons', count: 333, iconifyCategory: 'General' },
  { id: 'solar', name: 'Solar', count: 7500, iconifyCategory: 'General' },
  { id: 'streamline', name: 'Streamline', count: 1070, iconifyCategory: 'General' },
  { id: 'system-uicons', name: 'System UIcons', count: 480, iconifyCategory: 'General' },
  { id: 'tdesign', name: 'TDesign Icons', count: 1550, iconifyCategory: 'General' },
  { id: 'teenyicons', name: 'Teenyicons', count: 1200, iconifyCategory: 'General' },
  { id: 'typcn', name: 'Typicons', count: 336, iconifyCategory: 'General' },
  { id: 'uiw', name: 'UIW Icons', count: 330, iconifyCategory: 'General' },
  { id: 'vaadin', name: 'Vaadin Icons', count: 636, iconifyCategory: 'General' },
  { id: 'wpf', name: 'Icons8 Windows', count: 256, iconifyCategory: 'General' },
  { id: 'zondicons', name: 'Zondicons', count: 205, iconifyCategory: 'General' },
  // Brands
  { id: 'logos', name: 'SVG Logos', count: 1500, iconifyCategory: 'Brands / Social' },
  { id: 'simple-icons', name: 'Simple Icons', count: 3100, iconifyCategory: 'Brands / Social' },
  { id: 'skill-icons', name: 'Skill Icons', count: 300, iconifyCategory: 'Brands / Social' },
  { id: 'devicon', name: 'Devicon', count: 900, iconifyCategory: 'Brands / Social' },
  { id: 'devicon-plain', name: 'Devicon Plain', count: 900, iconifyCategory: 'Brands / Social' },
  { id: 'fa6-brands', name: 'Font Awesome Brands', count: 516, iconifyCategory: 'Brands / Social' },
  { id: 'mdi-brands', name: 'MDI Brands', count: 100, iconifyCategory: 'Brands / Social' },
  // Font Awesome
  { id: 'fa', name: 'Font Awesome 4', count: 786, iconifyCategory: 'General' },
  { id: 'fa6-regular', name: 'Font Awesome Regular', count: 162, iconifyCategory: 'General' },
  { id: 'fa6-solid', name: 'Font Awesome Solid', count: 1390, iconifyCategory: 'General' },
  { id: 'fa-regular', name: 'Font Awesome 5 Regular', count: 151, iconifyCategory: 'General' },
  { id: 'fa-solid', name: 'Font Awesome 5 Solid', count: 1001, iconifyCategory: 'General' },
  // Maps / Location
  { id: 'map', name: 'Map Icons', count: 230, iconifyCategory: 'Maps' },
  { id: 'gis', name: 'GIS Map Icons', count: 400, iconifyCategory: 'Maps' },
  { id: 'maki', name: 'Maki', count: 212, iconifyCategory: 'Maps' },
  // Emoji
  { id: 'twemoji', name: 'Twitter Emoji', count: 3786, iconifyCategory: 'Emoji' },
  { id: 'noto', name: 'Noto Emoji', count: 3785, iconifyCategory: 'Emoji' },
  { id: 'emojione', name: 'Emoji One', count: 3826, iconifyCategory: 'Emoji' },
  { id: 'openmoji', name: 'OpenMoji', count: 4039, iconifyCategory: 'Emoji' },
  { id: 'fxemoji', name: 'FxEmoji', count: 1034, iconifyCategory: 'Emoji' },
  // Flags
  { id: 'circle-flags', name: 'Circle Flags', count: 346, iconifyCategory: 'Flags' },
  { id: 'emojione-v1', name: 'EmojiOne v1 Flags', count: 246, iconifyCategory: 'Flags' },
  { id: 'flag', name: 'Flag Icons', count: 530, iconifyCategory: 'Flags' },
  { id: 'flagpack', name: 'Flagpack', count: 259, iconifyCategory: 'Flags' },
  // Spinners / Animated
  { id: 'eos-icons', name: 'EOS Icons', count: 1000, iconifyCategory: 'Animated' },
  { id: 'svg-spinners', name: 'SVG Spinners', count: 43, iconifyCategory: 'Animated' },
  { id: 'line-md', name: 'Material Line Animated', count: 400, iconifyCategory: 'Animated' },
  // Games
  { id: 'game-icons', name: 'Game Icons', count: 4052, iconifyCategory: 'Gaming' },
  { id: 'mdi-gaming', name: 'Gaming Icons', count: 100, iconifyCategory: 'Gaming' },
  // Health / Medical
  { id: 'healthicons', name: 'Health Icons', count: 1700, iconifyCategory: 'Health & Medical' },
  { id: 'medical-icon', name: 'Medical Icons', count: 148, iconifyCategory: 'Health & Medical' },
  // Weather
  { id: 'wi', name: 'Weather Icons', count: 228, iconifyCategory: 'Weather' },
  { id: 'meteocons', name: 'Meteocons', count: 182, iconifyCategory: 'Weather' },
  // Accessibility
  { id: 'icon-park', name: 'Icon Park', count: 2658, iconifyCategory: 'General' },
  { id: 'icon-park-outline', name: 'Icon Park Outline', count: 2658, iconifyCategory: 'General' },
  { id: 'icon-park-solid', name: 'Icon Park Solid', count: 624, iconifyCategory: 'General' },
  { id: 'icon-park-twotone', name: 'Icon Park TwoTone', count: 2658, iconifyCategory: 'General' },
  // Misc
  { id: 'uil', name: 'Unicons Line', count: 1206, iconifyCategory: 'General' },
  { id: 'uis', name: 'Unicons Solid', count: 210, iconifyCategory: 'General' },
  { id: 'uit', name: 'Unicons Thin', count: 214, iconifyCategory: 'General' },
  { id: 'uim', name: 'Unicons Monochrome', count: 296, iconifyCategory: 'General' },
  { id: 'bx', name: 'BoxIcons', count: 824, iconifyCategory: 'General' },
  { id: 'bxl', name: 'BoxIcons Logos', count: 177, iconifyCategory: 'Brands / Social' },
  { id: 'bxs', name: 'BoxIcons Solid', count: 824, iconifyCategory: 'General' },
  { id: 'cil', name: 'CoreUI Free', count: 556, iconifyCategory: 'General' },
  { id: 'ci', name: 'coolicons', count: 444, iconifyCategory: 'General' },
  { id: 'clarity', name: 'Clarity Icons', count: 1053, iconifyCategory: 'General' },
  { id: 'entypo', name: 'Entypo', count: 411, iconifyCategory: 'General' },
  { id: 'entypo-social', name: 'Entypo Social', count: 76, iconifyCategory: 'Brands / Social' },
  { id: 'ep', name: 'Element Plus Icons', count: 300, iconifyCategory: 'General' },
  { id: 'flat-color-icons', name: 'Flat Color Icons', count: 329, iconifyCategory: 'General' },
  { id: 'fluent-emoji', name: 'Fluent Emoji', count: 1800, iconifyCategory: 'Emoji' },
  { id: 'fluent-emoji-flat', name: 'Fluent Emoji Flat', count: 1800, iconifyCategory: 'Emoji' },
  { id: 'fluent-mdl2', name: 'Fluent MDL2', count: 1280, iconifyCategory: 'General' },
  { id: 'foundation', name: 'Foundation Icons', count: 283, iconifyCategory: 'General' },
  { id: 'humbleicons', name: 'Humbleicons', count: 237, iconifyCategory: 'General' },
  { id: 'ic', name: 'Google Material Icons', count: 11000, iconifyCategory: 'General' },
  { id: 'icomoon-free', name: 'IcoMoon Free', count: 491, iconifyCategory: 'General' },
  { id: 'iconpark', name: 'IconPark', count: 300, iconifyCategory: 'General' },
  { id: 'il', name: 'Icalicons', count: 480, iconifyCategory: 'General' },
  { id: 'ion', name: 'Ionicons', count: 1356, iconifyCategory: 'General' },
  { id: 'ls', name: 'Losticon', count: 140, iconifyCategory: 'General' },
  { id: 'mage', name: 'Mage Icons', count: 800, iconifyCategory: 'General' },
  { id: 'memory', name: 'Memory Icons', count: 322, iconifyCategory: 'General' },
  { id: 'mi', name: 'Mono Icons', count: 200, iconifyCategory: 'General' },
  { id: 'mingcute', name: 'MingCute', count: 3200, iconifyCategory: 'General' },
  { id: 'nonicons', name: 'Nonicons', count: 112, iconifyCategory: 'General' },
  { id: 'nrk', name: 'NRK Icons', count: 162, iconifyCategory: 'General' },
  { id: 'ooui', name: 'OOUI Icons', count: 326, iconifyCategory: 'General' },
  { id: 'openmoji', name: 'OpenMoji', count: 4039, iconifyCategory: 'Emoji' },
  { id: 'pepicons', name: 'Pepicons', count: 540, iconifyCategory: 'General' },
  { id: 'ph', name: 'Phosphor', count: 9072, iconifyCategory: 'General' },
  { id: 'raphael', name: 'Raphael', count: 267, iconifyCategory: 'General' },
  { id: 'si-glyph', name: 'SmartIcons Glyph', count: 342, iconifyCategory: 'General' },
  { id: 'subway', name: 'Subway Icon Set', count: 310, iconifyCategory: 'General' },
  { id: 'tabler', name: 'Tabler Icons', count: 6092, iconifyCategory: 'General' },
  { id: 'token', name: 'Token Icons', count: 400, iconifyCategory: 'Brands / Social' },
  { id: 'topcoat', name: 'TopCoat Icons', count: 89, iconifyCategory: 'General' },
  { id: 'twemoji', name: 'Twitter Emoji', count: 3786, iconifyCategory: 'Emoji' },
  { id: 'typcn', name: 'Typicons', count: 336, iconifyCategory: 'General' },
  { id: 'uiw', name: 'UIW Icons', count: 330, iconifyCategory: 'General' },
  { id: 'unjs', name: 'UnJS Packages', count: 80, iconifyCategory: 'Brands / Social' },
  { id: 'vscode-icons', name: 'VS Code Icons', count: 1200, iconifyCategory: 'Brands / Social' },
  { id: 'websymbol', name: 'Web Symbols Liga', count: 85, iconifyCategory: 'General' },
  { id: 'whh', name: 'WebHostingHub Glyphs', count: 2125, iconifyCategory: 'General' },
  { id: 'wi', name: 'Weather Icons', count: 228, iconifyCategory: 'Weather' },
].filter((s, i, arr) => arr.findIndex(x => x.id === s.id) === i); // deduplicate

// Category IDs that exist in local chunks — use local data for these
export const LOCAL_SET_IDS = new Set([
  'all', 'all brands', 'arrows', 'bi', 'brands & companies', 'business',
  'carbon', 'dev', 'feather', 'finance', 'fluent', 'heroicons', 'interface',
  'lucide', 'material', 'mdi', 'microsoft', 'octicon', 'ph', 'radix', 'ri',
  'social', 'tabler', 'technology', 'weather',
]);

export const POPULAR_PREFIXES = [
  'ph', 'tabler', 'mdi', 'fluent', 'ri', 'bi', 'heroicons', 'lucide', 'carbon', 'octicon',
];

// ── Cache helpers ────────────────────────────────────────────────────────────
function cacheGet(key) {
  try {
    const raw = localStorage.getItem('ib-web-' + key);
    if (!raw) return null;
    const { data, ts } = JSON.parse(raw);
    return (Date.now() - ts > CACHE_TTL) ? null : data;
  } catch { return null; }
}

function cacheSet(key, data) {
  try {
    localStorage.setItem('ib-web-' + key, JSON.stringify({ data, ts: Date.now() }));
  } catch { /* storage full — skip */ }
}

// ── Load all Iconify collections (150+ sets) ─────────────────────────────────
export async function loadAllCollections() {
  const cached = cacheGet('collections');
  if (cached) return cached;

  // Always return the static list immediately; try to enrich from API
  const staticSets = STATIC_COLLECTIONS.map(s => ({
    ...s,
    prefix: s.id,
    isLocal: LOCAL_SET_IDS.has(s.id),
  }));

  try {
    const r = await fetch(`${ICONIFY_BASE}/collections`);
    if (!r.ok) throw new Error(`${r.status}`);
    const data = await r.json();

    // Merge API data (authoritative counts + any sets not in static list)
    const staticIds = new Set(staticSets.map(s => s.id));
    const apiSets = Object.entries(data).map(([prefix, info]) => ({
      id: prefix,
      prefix,
      name: info.name || prefix,
      count: info.total || 0,
      iconifyCategory: info.category || 'Other',
      isLocal: LOCAL_SET_IDS.has(prefix),
    }));

    // API sets take priority; add any API-only sets not in static list
    const apiMap = Object.fromEntries(apiSets.map(s => [s.id, s]));
    const merged = [
      ...staticSets.map(s => apiMap[s.id] || s),
      ...apiSets.filter(s => !staticIds.has(s.id)),
    ];

    cacheSet('collections', merged);
    return merged;
  } catch {
    // Network unavailable — return static list (no cache, so next load retries)
    return staticSets;
  }
}

// ── Fetch icons for a non-local prefix via Iconify API ───────────────────────
export async function fetchIconsFromIconify(prefix, limit = 80, offset = 0) {
  try {
    // 1. Get icon name list (cached)
    let names = cacheGet(`names-${prefix}`);
    if (!names) {
      const r = await fetch(`${ICONIFY_BASE}/collection?prefix=${prefix}`);
      if (!r.ok) return [];
      const data = await r.json();
      names = [];
      if (Array.isArray(data.uncategorized)) names.push(...data.uncategorized);
      if (data.categories) {
        Object.values(data.categories).forEach(arr => Array.isArray(arr) && names.push(...arr));
      }
      cacheSet(`names-${prefix}`, names);
    }

    const batch = names.slice(offset, offset + limit);
    if (!batch.length) return [];

    // 2. Fetch SVG bodies
    const r = await fetch(`${ICONIFY_BASE}/${prefix}.json?icons=${batch.join(',')}`);
    if (!r.ok) return [];
    const data = await r.json();
    const dw = data.width || 24;
    const dh = data.height || 24;

    return batch
      .filter(n => data.icons?.[n]?.body)
      .map(n => ({
        id: `${prefix}_${n}`,
        name: n,
        category: prefix,
        filename: `${n}.svg`,
        svgContent: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${data.icons[n].width || dw} ${data.icons[n].height || dh}">${data.icons[n].body}</svg>`,
        tags: [prefix, n, ...n.split(/[-_]/)].filter(Boolean),
        downloads: 0,
        featured: false,
        isIconify: true,
      }));
  } catch {
    return [];
  }
}

// ── Search across Iconify sets ────────────────────────────────────────────────
export async function searchIconify(query, prefix, limit = 80) {
  try {
  const pfx = (prefix && prefix !== 'all') ? `&prefixes=${prefix}` : '';
  const r = await fetch(
    `${ICONIFY_BASE}/search?query=${encodeURIComponent(query)}&limit=${limit}${pfx}`
  );
  if (!r.ok) return [];
  const data = await r.json();

  // Group icon IDs by prefix for batch fetching
  const byPrefix = {};
  (data.icons || []).forEach(id => {
    const i = id.indexOf(':');
    const p = id.slice(0, i);
    const n = id.slice(i + 1);
    (byPrefix[p] = byPrefix[p] || []).push(n);
  });

  const chunks = await Promise.all(
    Object.entries(byPrefix).map(async ([p, ns]) => {
      const resp = await fetch(`${ICONIFY_BASE}/${p}.json?icons=${ns.join(',')}`);
      if (!resp.ok) return [];
      const d = await resp.json();
      const dw = d.width || 24;
      const dh = d.height || 24;
      return ns
        .filter(n => d.icons?.[n]?.body)
        .map(n => ({
          id: `${p}_${n}`,
          name: n,
          category: p,
          filename: `${n}.svg`,
          svgContent: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${d.icons[n].width || dw} ${d.icons[n].height || dh}">${d.icons[n].body}</svg>`,
          tags: [p, n, ...n.split(/[-_]/)].filter(Boolean),
          downloads: 0,
          featured: false,
          isIconify: true,
        }));
    })
  );

  return chunks.flat().slice(0, limit);
  } catch {
    return [];
  }
}
